<template>
    <div>
        <li>
            <div class="color_square" :style="backgroudColor"/> {{ stateString }}
        </li>
    </div>
</template>

<script>

export default {
    props: {
        state: Object,
        palette: Array
    },
    data() {
        return {
        }
    },
    watch: {

    },
    mounted() {

    },
    computed: {
        stateString: function() {
            return this.state.title ?? '-'
        },
        backgroudColor: function() {
            return 'background-color:' + this.palette[this.state.paletteIndex]
        }
    },
    methods: {

    }
}
</script>
